import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Sidebar from "./components/sidebar";
import FactoryImages from "./pages/factoryimgaes";
import ProductImages from "./pages/productimages";
import { useState } from "react";
import LoginPage from "./auth/login";

export default function App() {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);

  const handleLoginSuccess = () => {
    setIsAuthenticated(true);
  };

  return (
    <BrowserRouter>
      {!isAuthenticated ? (
        <Routes>
          <Route
            path="*"
            element={<LoginPage onLoginSuccess={handleLoginSuccess} />}
          />
        </Routes>
      ) : (
        <div className="flex">
          <Sidebar />
          <main className="flex-1 bg-gray-50">
            <Routes>
              <Route path="/" element={<Navigate to="/factory" replace />} />
              <Route path="/factory" element={<FactoryImages />} />
              <Route path="/products" element={<ProductImages />} />
            </Routes>
          </main>
        </div>
      )}
    </BrowserRouter>
  );
}
